<template>
  <v-form ref="form" v-model="valid" @submit.prevent="keycloakLogin" lazy-validation class="form px-10">
    <h2 class="text-center font-weight-light my-3">{{ $t('common.login-title') }}</h2>
    <label for="stampyt-email" class="login-email-label">{{ $t('common.email') }}</label>
    <v-text-field
      type="text"
      v-model="email"
      color="grey lighten-4"
      :rules="[emailRules]"
      placeholder="john@gmail.com"
      autofocus
      outlined
      dense
    />

    <v-btn
      class="text-capitalize font-weight-regular"
      color="primary"
      rounded
      type="submit"
      :disabled="!valid"
      :dark="valid"
      depressed
      block
      >{{ $t('common.login') }}</v-btn
    >
  </v-form>
</template>

<script>
import { getIdentityProvidersByEmail } from '@/helpers/identityProviders'
import { emailFormat, isValidEmailFormat } from '@/helpers/inputsRulesFormatter'

export default {
  data() {
    return {
      email: '',
      valid: false
    }
  },

  mounted() {
    const userLocalStorage = localStorage.getItem('stampytUser')

    if (!userLocalStorage) return

    if (isValidEmailFormat(userLocalStorage)) {
      this.email = userLocalStorage
    }
  },

  computed: {
    emailRules(value) {
      return emailFormat(value.email, this.$t('common.emailRequired'), this.$t('common.emailFormat'))
    }
  },

  methods: {
    async keycloakLogin() {
      await this.$refs.form.validate()

      if (!this.valid) return
      const identityProvider = await getIdentityProvidersByEmail(this.email)

      localStorage.setItem('stampytUser', this.email)

      this.$keycloak.login({
        idpHint: identityProvider,
        loginHint: this.email
      })
    }
  }
}
</script>

<style lang="css" scoped>
.login-email-label {
  font-size: 12px;
}
</style>
